import helper from "actions/helper";

function formXlsxItem(itemsData, text, style) {

    itemsData.forEach((it, i) => {
        const { name, altCode, value, items } = it;
        if (!altCode) {
            text.push([name]);
            const pos = text.length;
            style.push({
                name: "color",
                value: "87CEEB",
                start: [pos, 1],
                end: [pos, 3]
            });
            style.push({
                name: "border",
                start: [pos, 1],
                end: [pos, 3]
            });
            style.push({
                name: "bold",
                start: [pos, 1],
                end: [pos, 3]
            });
        } else {
            text.push([altCode, name, helper.number.toSum(value)]);
            style.push({
                name: "wrapText",
                start: [text.length, 1],
                end: [text.length, 3]
            });
        }

        if (items && items.length > 0)
            formXlsxItem(items, text, style);
    });
}

export default function Price(prices, validity) {
    if (!prices)
        return false;

    const text = [
        ["ООО Белая радуга-1 ул. Нижняя Красносельская д. 35 стр. 50 тел.+ 7 (499) 703 52-25"],
        ["", "Прайс, действующий c " + validity, ""],
        ["Код позиции", "Название позиции", "Цена"],
    ];

    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "border",
        start: [3, 1],
        end: [3, 3]
    }, {
        name: "bold",
        start: [3, 1],
        end: [3, 3]
    }];

    formXlsxItem(prices, text, style);

    const width = [
        { key: 'A', width: 20 },
        { key: 'B', width: 100 },
        { key: 'C', width: 20 },
    ];

    const data = { text, style, width };

    helper.xlsx.exportToExcel(data, "Price.xlsx");

}
